import { createBrowserHistory } from 'history';

// Yes, this is the proper way to initialize history IF you need the history object
// Which we DO need in the <app> component to listen to history changes and to push
export default createBrowserHistory();
